import { ApiEndpoints } from "../../utils/app-constants";
import { toCondensedDate } from "../../utils/date-utils";
import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../utilities/document-request";
import { API_METHODS } from "../utilities/type-models";

export class TerreHautePaperworkDocument implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab : boolean = false;
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    public url : string = '';

    constructor(runIds : string) {
        this.url = ApiEndpoints.REPORTS_PRODUCTION_TERREHAUTEPAPERWORK_REPORT.formattify(runIds);
        this.filename = `Paperwork_${ toCondensedDate(new Date()) }`;
    }

}
